export enum RedirectMethods {
  RedirectIframe = 'redirect_iframe',
  FormIframe = 'form_iframe',
  RedirectUrl = 'redirect_url',
  Redirect3ds = 'redirect_3ds',
  RedirectForm = 'redirect_form',
  RedirectQRCode = 'redirect_qr_code',
  RedirectNone = 'redirect_none'
}
